'use client';

import { useCallback } from 'react';
import { useTranslations } from 'next-intl';
import { toasterApi } from '../../toast/ToastProvider';
import type { ApplicationDocumentationController } from './applicationDocumentation.types';

export type PersistDocumentationUrls = ({
  urls,
}: {
  urls: string[];
}) => Promise<boolean>;

export const usePersistDocumentationUrls = ({
  applicationId,
  saveDocumentationUrls,
}: {
  applicationId: string | null;
  saveDocumentationUrls: ApplicationDocumentationController['saveDocumentationUrls'];
}): PersistDocumentationUrls => {
  const t = useTranslations(
    'designSystem.documentsReports.applicationDocumentation',
  );

  return useCallback(
    async ({ urls }: { urls: string[] }) => {
      if (!applicationId) {
        return false;
      }

      try {
        await saveDocumentationUrls({
          applicationId,
          documentationUrls: urls,
        });

        return true;
      } catch (error) {
        console.error(
          new Error('Failed to update documentation URLs', {
            cause: error instanceof Error ? error : new Error(String(error)),
          }),
        );
        toasterApi.error({
          title: t('errors.failedToSaveDocumentationUrls'),
          description: t('errors.pleaseTryAgain'),
        });

        return false;
      }
    },
    [applicationId, saveDocumentationUrls, t],
  );
};
